import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="bottom-right"
      closeButton={true}
      duration={4000}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-gray-100 group-[.toaster]:text-gray-900 group-[.toaster]:border-gray-200 group-[.toaster]:shadow-lg group-[.toaster]:rounded-xl",
          description: "group-[.toast]:text-gray-500",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          closeButton:
            "bg-gray-400! text-white! border-0! hover:bg-gray-500! rounded-full! w-5! h-5! p-0! top-2! right-2! left-auto! transform-none! [&>svg]:w-3! [&>svg]:h-3!",
          // Success toast - verde deschis
          success:
            "group-[.toaster]:bg-green-50 group-[.toaster]:text-green-900 group-[.toaster]:border-green-200 [&>svg]:text-green-600",
          // Error toast - roșu deschis
          error:
            "group-[.toaster]:bg-red-50 group-[.toaster]:text-red-900 group-[.toaster]:border-red-200 [&>svg]:text-red-600",
          // Info toast - gri deschis (default)
          info:
            "group-[.toaster]:bg-gray-100 group-[.toaster]:text-gray-900 group-[.toaster]:border-gray-200 [&>svg]:text-gray-600",
          // Warning toast - galben deschis
          warning:
            "group-[.toaster]:bg-amber-50 group-[.toaster]:text-amber-900 group-[.toaster]:border-amber-200 [&>svg]:text-amber-600",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
